export default {
  isExtLink(url) {
    if (!url || url[0] === '/') {
      return false;
    }

    return url.indexOf(window.location.host) < 0;
  },
  getLinkIcon(url) {
    return this.isExtLink(url) ? 'external-link' : 'arrow';
  },
};
